export default {
  path: "/pagesInvestment",
  name: "pagesInvestment",
  component: () => import("./index"),
  redirect: "/pagesInvestment/index",
  children: [
    {
      path: "index",
      name: "首页",
      meta: {
        image:require("../../assets/images/pagesInvestment/banner.png")
      },
      component: () => import("./pagesInvestmentIndex")
    },
    {
      path: "search",
      name: "搜索",
      meta: {
        breadNumber: 1,
        image:require("../../assets/images/pagesInvestment/banner.png")
      },
      component: () => import("./search")
    },
    {
      path: "city/detail",
      name: "城市介绍",
      meta: {
        breadNumber: 1,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./city/detail")
    },
    {
      path: "leadingIndustry/list",
      name: "主导产业",
      meta: {
        breadNumber: 1,
        image:require("../../assets/images/pagesInvestment/zdban.png")
      },
      component: () => import("./leadingIndustry/list")
    },
    {
      path: "leadingIndustry/detail",
      name: "产业详情",
      meta: {
        breadNumber: 2,
        image:require("../../assets/images/pagesInvestment/zdban.png")
      },
      component: () => import("./leadingIndustry/detail")
    },
    {
      path: "industrialPark/list",
      name: "产业园区",
      meta: {
      
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./industrialPark/list")
    },
    {
      path: "industrialPark/detail",
      name: "详情",
      meta: {
        breadNumber: 2,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./industrialPark/detail")
    },
    {
      path: "keyEnterprise/list",
      name: "重点企业",
      meta: {
        breadNumber: 3,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./keyEnterprise/list")
    },
    {
      path: "keyEnterprise/detail",
      name: "企业详情",
      meta: {
        breadNumber: 4,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./keyEnterprise/detail")
    },

    {
      path: "comparison/list",
      name: "产业对比",
      meta: {
        breadNumber: 3,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./comparison/list")
    },
    {
      path: "industrialParks/list",
      name: "园区选择",
      meta: {
        breadNumber: 4,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./industrialPark/list")
    },
    {
      path: "comparison/detail",
      name: "综合对比",
      meta: {
        breadNumber: 4,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./comparison/detail")
    },
    {
      path: "policy/list",
      name: "招商政策",
      meta: {
        breadNumber: 1,
        image:require("../../assets/images/pagesInvestment/zcban.png")
      },
      component: () => import("./policy/list")
    },
    {
      path: "policy/detail",
      name: "政策详情",
      meta: {
        breadNumber: 2,
        image:require("../../assets/images/pagesInvestment/zcban.png")
      },
      component: () => import("./policy/detail")
    },
    {
      path: "toInvest/detail",
      name: "我要投资",
      meta: {
        breadNumber: 3,
        image:require("../../assets/images/pagesInvestment/detailBanner.png")
      },
      component: () => import("./toInvest/detail")
    },
    {
      path: "plot/list",
      name: "地块资源",
      meta: {
        breadNumber: 1,
        image:require("../../assets/images/pagesInvestment/dkban.png")
      },
      component: () => import("./plot/list")
    },
    {
      path: "plot/detail",
      name: "地块信息",
      meta: {
        breadNumber: 2,
        image:require("../../assets/images/pagesInvestment/dkban.png")
      },
      component: () => import("./plot/detail")
    },
    {
      path: "plantInfo/list",
      name: "厂房信息",
      meta: {
        breadNumber: 1,
        image:require("../../assets/images/pagesInvestment/cfban.png")
      },
      component: () => import("./plantInfo/list")
    },
    {
      path: "plantInfo/detail",
      name: "厂房详情",
      meta: {
        breadNumber: 2,
        image:require("../../assets/images/pagesInvestment/cfban.png")
      },
      component: () => import("./plantInfo/detail")
    },
    
    {
      path: "project/list",
      name: "招商项目",
      meta: {
        breadNumber: 1,
        image:require("../../assets/images/pagesInvestment/cfban.png")
      },
      component: () => import("./project/list")
    },
    {
      path: "project/detail",
      name: "项目详情",
      meta: {
        breadNumber: 2,
        image:require("../../assets/images/pagesInvestment/cfban.png")
      },
      component: () => import("./project/detail")
    },
  ]
};



// WEBPACK FOOTER //
// ./src/views/pagesInvestment/router.js